import {BackendApi} from "../api.ts";
import {User} from "./User.ts";
import {setCurrentBusinessId} from "../../utils/OrgManagement.ts";

export class HTTPCurrentUserRepository {
    constructor(readonly api: BackendApi) {
    }

    private async pullUserData(): Promise<User | null> {
        const result = await this.api.AccessControl__whoAmI({})
        return User.fromApiResponse(result, this.api)
    }

    public async getCurrentUser(): Promise<User> {

        try {
            return await this.pullUserData()
        } catch (error: any) {
            if (error.message === 'Forbidden') {
                setCurrentBusinessId(null)
                return await this.pullUserData()
            }
            throw error
        }

    }
}
